import { fromEvent, map, merge, startWith } from 'rxjs';

export const onlineStatus$ = merge(fromEvent(window, 'online'), fromEvent(window, 'offline')).pipe(
  startWith(navigator.onLine),
  map(() => navigator.onLine),
);

export const visibilityStatus$ = fromEvent(document, 'visibilitychange').pipe(
  startWith(document.visibilityState),
  map(() => document.visibilityState === 'visible'),
);
